import { Children, isValidElement } from 'react';
export function toArrayChildren(children) {
    const ret = [];
    Children.forEach(children, child => {
        if (isValidElement(child)) {
            ret.push(child);
        }
    });
    return ret;
}
export function findChildInChildrenByKey(children, key) {
    if (children) {
        return children.find(child => child && child.key === key);
    }
}
export function findShownChildInChildrenByKey(children, key, hiddenProp) {
    let ret;
    if (children) {
        children.forEach(child => {
            if (child && child.key === key && !child.props[hiddenProp]) {
                if (ret) {
                    throw new Error('two child with same key for animate children');
                }
                ret = child;
            }
        });
    }
    return ret;
}
// export function findHiddenChildInChildrenByKey(children, key, showProp):boolean {
//   let found = false;
//   if (children) {
//     children.forEach(function (child) {
//       if (found) {
//         return;
//       }
//       found = child && child.key === key && !child.props[showProp];
//     });
//   }
//   return found;
// }
export function isSameChildren(c1, c2, hiddenProp) {
    let same = c1.length === c2.length;
    if (same) {
        c1.forEach((child, index) => {
            const child2 = c2[index];
            if (child && child2) {
                if ((child && !child2) || (!child && child2)) {
                    same = false;
                }
                else if (child.key !== child2.key) {
                    same = false;
                }
                else if (hiddenProp && child.props[hiddenProp] !== child2.props[hiddenProp]) {
                    same = false;
                }
            }
        });
    }
    return same;
}
export function mergeChildren(prev, next) {
    let ret = [];
    const nextChildrenPending = {};
    let pendingChildren = [];
    prev.forEach(child => {
        if (child && child.key && findChildInChildrenByKey(next, child.key)) {
            if (pendingChildren.length) {
                nextChildrenPending[child.key] = pendingChildren;
                pendingChildren = [];
            }
        }
        else {
            pendingChildren.push(child);
        }
    });
    next.forEach(child => {
        if (child && child.key && {}.hasOwnProperty.call(nextChildrenPending, child.key)) {
            ret = ret.concat(nextChildrenPending[child.key]);
        }
        ret.push(child);
    });
    return ret.concat(pendingChildren);
}
